const Types = {
  SET_RECAPTCHA: '@recaptcha/SET_RECAPTCHA',
  DISABLE_RECAPTCHA: '@recaptcha/DISABLE_RECAPTCHA',
  RESET_RECAPTCHA: '@recaptcha/RESET_RECAPTCHA',
};

export default Types;
